import { render } from "./BrokerProfile.vue?vue&type=template&id=008c7fdf&scoped=true"
import script from "./BrokerProfile.vue?vue&type=script&lang=js"
export * from "./BrokerProfile.vue?vue&type=script&lang=js"

import "./BrokerProfile.vue?vue&type=style&index=0&id=008c7fdf&scoped=true&lang=css"

import exportComponent from "C:\\Users\\aiden\\OneDrive - Qismat\\Development\\brydg-bdp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-008c7fdf"]])

export default __exports__